import cn from "@utils/cn";
import Image from "next/image";
import { ChangeEvent, FC, useState } from "react";

import Icon from "@/components/ui/Icon/Icon";
import { ModalToolOption } from "@/types";

const OptionField: FC<ModalToolOption> = ({ option, variant, isChecked, optionsLenght, onCheckChange, forwardId }) => {
  return (
    <div className={cn("w-[calc(100%-2px)] md:w-full flex-[1_1_calc(25%-16px)] mx-auto  md:m-xs relative ")}>
      {isChecked && option.image && option.title && (
        <div className="flex h-[18px] w-[18px] justify-center items-center bg-gold-gradient rounded-full absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
          <Icon name="check-single" size="12" className=" stroke-black " />
        </div>
      )}
      <div
        className={cn(
          "w-full h-full rounded-xl relative text-center  p-s font-medium flex flex-col justify-center overflow-hidden outline-gray-10 outline-1 outline group min-h-[80px] md:min-h-auto",
          isChecked ? "bg-gold-gradient outline-gold" : "hover:gray-gradient hover:text-black hover:outline-gray",
          isChecked && (!option.image && option.title ? "text-black" : option.title && " outline-2"),
          option.image &&
            option.title &&
            (optionsLenght && optionsLenght <= 4 ? "aspect-square md:max-h-[40dvh] gt-filter__square " : "aspect-16-9 h-[136px] md:max-h-[17dvh]"),
          option.image && option.title && "justify-end hover:outline-2 hover:outline-gold hover:text-white",
        )}
        style={
          option.image && option.title ? { backgroundImage: `url(${option.image.url})`, backgroundSize: "cover", backgroundPosition: "center" } : {}
        }
      >
        {option.image && option.title && <div className="img-overlay-2 absolute top-0 left-0 right-0 bottom-0"></div>}
        <div className="z-10">
          {option.title && <div>{option.title}</div>}
          {option.description && <p className="font-secondary-light"> {option.description}</p>}
          {!option.title && option.image && (
            <Image
              src={option.image.url}
              width={140}
              height={option.image.height || 112}
              alt={option.image.title || ""}
              className={cn("inline-flex h-auto", isChecked ? "invert" : "group-hover:invert")}
            />
          )}
        </div>
        <input
          aria-label={option.title}
          name={option.title}
          className="absolute w-full h-full appearance-none top-0 left-0 z-10 hover:cursor-pointer"
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            onCheckChange(forwardId ? option.id : option.title!);
          }}
          type={variant === "multi" ? "checkbox" : "radio"}
          checked={isChecked}
        />
      </div>
    </div>
  );
};
export default OptionField;
